module.exports = __webpack_public_path__ + "img/BLCA_CD4Tconv.40d6f6a1.png";